import React from 'react';
import { ShieldCheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1a1a2e] py-14 px-4 border-t border-white/5" data-id="element-174">
      <div className="container mx-auto max-w-3xl" data-id="element-175">
        <div ref={ref1} className={`reveal relative bg-gradient-to-br from-[#1a3a2a] to-[#0f2a1a] rounded-3xl p-6 md:p-10 border border-green-900/50 shadow-2xl text-center overflow-hidden ${vis1 ? 'is-visible' : ''}`} data-id="element-176">
          <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-green-500/30 rounded-tl-3xl" data-id="element-177"></div>
          <div className="absolute bottom-0 right-0 w-20 h-20 border-b-4 border-r-4 border-green-500/30 rounded-br-3xl" data-id="element-178"></div>

          <div className="relative z-10" data-id="element-179">
            <img src="https://cdn.magicpatterns.com/uploads/koUD989NTx7Hr64pDomKrS/ea2f6b28975c2ded20e94d7e88c8db5f_-_Editado_(2).png" alt="Garantía 7 Días" className="w-40 h-40 md:w-52 md:h-52 object-contain mx-auto mb-6" data-id="element-180" />

            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-181">
              Probalo 7 días sin riesgo.
            </h2>

            <p className="text-lg md:text-xl text-green-100/80 leading-relaxed max-w-xl mx-auto mb-6" data-id="element-182">
              Si sentís que no es para vos, te devolvemos el 100% de tu dinero.
            </p>

            <div className="text-green-400 font-bold text-lg tracking-wide uppercase space-y-2" data-id="element-183">
              <p data-id="element-184">Sin preguntas. Sin culpa. Sin riesgo.</p>
              <p className="text-xl text-white" data-id="element-185">Tu decisión está protegida.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}